"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitAdministrativeDocumentsStepCommand = void 0;
const StepCommand_1 = require("../../common/command/StepCommand");
const validator_1 = require("@leavy/validator");
const OnboardingId_1 = require("../../common/domain/OnboardingId");
const cq_core_1 = require("@leavy/cq-core");
const base_1 = require("../../base");
let SubmitAdministrativeDocumentsStepCommand = class SubmitAdministrativeDocumentsStepCommand extends StepCommand_1.StepCommand {
    constructor() {
        super(...arguments);
        /**
         * The identifier of the onboarding to which the step belongs. Must be "HOD".
         */
        this.onboardingId = OnboardingId_1.OnboardingId.HOD;
    }
};
__decorate([
    (0, validator_1.Equals)(OnboardingId_1.OnboardingId.HOD),
    __metadata("design:type", String)
], SubmitAdministrativeDocumentsStepCommand.prototype, "onboardingId", void 0);
SubmitAdministrativeDocumentsStepCommand = __decorate([
    (0, cq_core_1.RpcInvocable)({
        namespace: base_1.ONBOARDING_SERVICE_NAME,
        alias: "submit_administrative_documents_step",
    })
], SubmitAdministrativeDocumentsStepCommand);
exports.SubmitAdministrativeDocumentsStepCommand = SubmitAdministrativeDocumentsStepCommand;
//# sourceMappingURL=SubmitAdministrativeDocumentsStepCommand.js.map